import GridPage from "components/layout/GridPage";
import { List, ListItem, Typography, Switch, Link } from "@mui/material";
import WithDividers from "components/helpers/WithDividers";
import ListItemText from "@mui/material/ListItemText";
import React, { useState } from "react";
import {
  FEATURE_FLAGS,
  FeatureFlag,
  isFeatureEnabled,
} from "components/helpers/GatedComponent";
import { useUpdateFeatureFlag } from "services/advisor";

import useIsMobile from "components/hooks/useIsMobile";
import { refreshToken } from "services/api";

const Feature = ({
  flag,
  onFeatureToggle,
}: {
  flag: FeatureFlag;
  onFeatureToggle: () => Promise<void>;
}) => {
  const [checked, setChecked] = useState(isFeatureEnabled(flag.value));
  const { request, loading } = useUpdateFeatureFlag();

  // refreshToken
  const onChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;
    await request({
      flagName: flag.value,
      enabled: newValue,
    });
    setChecked(newValue);
    await onFeatureToggle();
  };
  return (
    <ListItem>
      <ListItemText
        id="switch-label-family-"
        primary={flag.title}
        secondary={flag.description}
      />
      <Switch
        edge="end"
        onChange={onChange}
        checked={checked}
        disabled={loading}
        inputProps={{
          "aria-labelledby": "switch-label-family-",
        }}
      />
    </ListItem>
  );
};

export default () => {
  const isMobile = useIsMobile();
  const [refreshKey, setRefreshKey] = useState(0);

  const handleFeatureToggle = async () => {
    // Refresh the current user object to get the new feature flags.
    await refreshToken();
    // Force re-render to update the UI with new feature flags
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <GridPage
      sx={{
        margin: isMobile ? "" : "64px auto",
        maxWidth: "1000px",
        padding: isMobile ? "20px" : "0",
      }}
    >
      <Typography variant="title" id="tableTitle">
        Feature switches
      </Typography>
      <Typography variant={"body"}>
        Turn features on and off. Changes may require a page{" "}
        <Link
          href={"#"}
          onClick={() => {
            window.location.reload();
          }}
        >
          refresh
        </Link>
        .
      </Typography>
      <List
        sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
        component="nav"
        aria-labelledby="nested-list-subheader"
        key={refreshKey}
      >
        <WithDividers>
          {Object.values(FEATURE_FLAGS)
            .filter((flag) => !flag.adminOnly)
            .map((flag) => (
              <Feature
                key={flag.title}
                flag={flag}
                onFeatureToggle={handleFeatureToggle}
              />
            ))}
        </WithDividers>
      </List>
    </GridPage>
  );
};
